import { CategoriaMeta, GrupoBeneficio, GrupoMeta } from '../../types/Plan';

// `textoSobre` se mudó a `utils/color.ts`: también lo necesita la tarjeta de
// plan activo de /inicio, que pinta el color que manda Salesforce.

/** Texto del porcentaje de un beneficio, con el prefijo "hasta" cuando es un tope. */
export const formatearPorcentaje = (pct: number, esTope?: boolean): string => `${esTope ? 'hasta ' : ''}${pct}%`;

export interface GrupoConCategorias {
  grupo: GrupoBeneficio;
  alcance: string;
  categorias: CategoriaMeta[];
}

/** Agrupa las categorías de beneficio por grupo, respetando el orden de `grupos`. */
export const agruparPorGrupo = (categorias: CategoriaMeta[], grupos: GrupoMeta[]): GrupoConCategorias[] =>
  grupos.map((g) => ({
    grupo: g.id,
    alcance: g.alcance,
    categorias: categorias.filter((c) => c.grupo === g.id),
  }));

/** Color de fondo de las bandas de sección ("credencial impresa" Gappex). */
export const COLOR_BANDA = '#264F6B';
